import numeral from 'numeral';
import { FormattersTypes } from '@/services/types/formatter'
import {FORMATS} from '@/services/constants/format';


export default ({ vtag, component, data, key, decimal = 2 }: FormattersTypes) => {
  component.tag = 'span';

  let val = data[key] || 0;
  const value = numeral(val).format(FORMATS[decimal]);

  return vtag('div', {class: 'class-name'},
    [vtag('span', {class: 'factor-1x'}, ['1 : ', value])])
}
